import { RouteConfig } from 'vue-router';
import Equipments from '@/modules/equipments/views/Equipments.vue';

export const equipmentsRouter: RouteConfig[] = [
    {
        path: 'dayco-equipments',
        name: 'dayco-equipments',
        component: Equipments,
        props: true,
    },
];
